import React from 'react';
import { WarningCircle } from '@phosphor-icons/react';
import telegramService from '../services/telegram';

const DevModeIndicator = () => {
  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  // Only show if not running in Telegram
  if (telegramService.isRunningInTelegramApp()) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-yellow-500 text-white px-3 py-2 rounded-lg flex items-center gap-2 text-sm font-bold">
        <WarningCircle size={16} />
        <span>DEV MODE</span>
      </div>
    </div>
  );
};

export default DevModeIndicator;
